import { IFtthOrchestrator } from "@nju/data-access-portal-orchestrator";

type IPaymentErrorCategory = Pick<
  keyof IFtthOrchestrator["paymentErrorCategory"],
  "CARDLIMIT" | "CARDERROR" | "BANKDECLINED" | "PIN" | "CARDBLOCKED"
>;
type IMessage = Record<keyof IPaymentErrorCategory, string>;

const messages: IMessage = {
  CARDLIMIT:
    "Sprawdź, czy na Twoim koncie w banku jest wystarczająca ilość środków lub czy nie został przekroczony limit płatności. Następnie ponów płatność.",
  CARDERROR:
    "Nie możemy zrealizować płatności dla podanej karty płatniczej. Zarządź swoją płatnością: dodaj inną kartę lub wybierz inną metodę płatności. Następnie ponów płatność.",
  BANKDECLINED: "Bank odrzucił Twoją płatność.",
  PIN: "Nie udało nam się pobrać płatności.",
  CARDBLOCKED:
    "Nie możemy zrealizować płatności dla podanej karty płatniczej. Zarządź swoją płatnością: dodaj inną kartę lub wybierz inną metodę płatności. Następnie ponów płatność.",
};

export function getPaymentErrorCategoryMessage(
  paymentErrorCategory: IFtthOrchestrator["paymentErrorCategory"],
) {
  if (
    !paymentErrorCategory ||
    paymentErrorCategory === "DW_LIMIT_EXCEEDED" ||
    paymentErrorCategory === "DEFAULT"
  ) {
    return "Dostaliśmy informację o problemie z Twoją płatnością.";
  }

  return messages[paymentErrorCategory];
}
